<template>
	<div>
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<!-- 标题背景 -->
		<div class="w-100 outDiv">
			<img src="../../assets/img/newsInformation/Information-banner.jpg" style="max-width: 100%;">
			<!-- 新闻列表 -->
			<div class="newsList">
				<!-- 左侧导航 -->
				<div class="leftNav">
					<div v-for="(item,index) in navList" :key="index" class="text-center listArr"
					:style="{backgroundColor:(index==0? '#C32A1A':'')}" :class="[index == 0 ? 'text-white' : '',
					activeIndex == index ? 'notOneBg' :'']"
					@click="activeNav(item,index)">
						{{item.title}}
					</div>
				</div>
				<!-- 右侧新闻列表 -->
				<div class="rightNewsList">
					<div style="min-height: 600px;">
						<div v-for="(item,index) in newsList" :key="index" class="listArr" @click="goNewsDetail(item)">
							<span class="newsTitle">{{item.name}}</span>
							<p class="newsDesc" style="font-size: 14px;">{{item.introduce}}</p>
							<p class="float-right newsDate">{{item.createAt}}</p>
						</div>
						<div v-if="newsList.length == 0 || !newsList" style="position: relative;top:150px">
							<el-empty description="没有更多了哦~" />
						</div>
					</div>
					<!-- 分页器 -->
					<div style="text-align: center;" class="py-4">
						<el-pagination background layout="prev, pager, next"
						@current-change="getNewsInformation" :current-page="paging.currPage"
						:page-size="paging.everySize" :total="paging.allNum">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<div>
			<Footer :bgColor="'#fafafa'" :border="true"></Footer>
		</div>
	</div>
</template>

<script>
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import Footer from '@/components/footer/footer.vue'
	export default{
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			Footer
		},
		data() {
			return {
				navList:[
					{title:'行业资讯'},
					{title:'知产资讯'},
					{title:'知产小知识'},
					{title:'资金扶持'},
					{title:'恒达资讯'}
				],
				activeIndex:1,
				activeUrl:'/zczx',
				newsList:[],
				paging: {currPage: 1, everySize: 10, allNum: 0},
				//检索条件
				condition: {
					type:''
				}
			}
		},
		created() {
			this.activeIndex = window.sessionStorage.getItem('newsInformationIndex') || 1
			this.condition.type = this.navList[this.activeIndex].title
			this.getNewsInformation()
		},
		methods: {
			// 获取热门推荐-热门专利数据
			getNewsInformation(currentPage){
				let vm = this
				// 区分分页与查询
				if(currentPage){
					vm.paging.currPage = currentPage;
				} else {
					vm.paging.currPage = 1;
				}
				this.axios.get('/api/industry/new/findAllByPage',{params:{
					currPage: vm.paging.currPage,
					everySize: vm.paging.everySize,
					type:vm.condition.type
				}}).then(res => {
					vm.newsList = res.data.data.industryNews
					vm.paging = res.data.data.pagingBean
				})
			},
			// 点击导航菜单切换右侧内容
			activeNav(item,index){
				if(index!==0){
					this.activeIndex = index
					this.condition.type = item.title
					this.$store.commit('activeNewsInformationIndex',this.activeIndex)
					this.getNewsInformation()
				}
			},
			// 点击后前往新闻详情页
			goNewsDetail(item){
				if(item.reprintMark){
					return window.open(item.reprintUrl, '_blank');
				}
				let routeData = this.$router.resolve({
					path:'/newsDetail',
					query:{
						id:item.id,
						mbx:'行业资讯',
						mbxLink:'/newsInformation'
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
	.outDiv{
		background-color: #F8F8F8;
		overflow: hidden;
	}
	/* 新闻列表 */
	.newsList{
		width: 1000px;
		min-height: 600px;
		margin: 0 auto;
		margin-top:40px;
		margin-bottom:50px;
		display: flex;
	}
	/* 左侧导航 */
	.newsList .leftNav{
		width: 260px;
	}
	.newsList .leftNav .listArr{
		width: 260px;
		height: 70px;
		line-height: 70px;
		font-size: 20px;
	}
	.newsList .leftNav .listArr:hover{
		cursor: pointer;
	}
	.newsList .rightNewsList{
		width: 810px;
		min-height: 600px;
		background-color: #fff;
	}
	.notOneBg{
		background-color:#ffe2df ;
	}
	/* 右侧新闻 */
	.rightNewsList .listArr{
		width: 810px;
		height: 178px;
		border-bottom: 1px solid #eee;
		padding:30px;
	}
	.rightNewsList .listArr:hover{
		cursor: pointer;
	}
	.rightNewsList .listArr .newsTitle{
		color: #666;
		font-size: 18px;
		font-weight: bold;
	}
	.rightNewsList .listArr .newsTitle:hover{
		color: #C32A1A;
	}
	.rightNewsList .listArr .newsDesc,{
		height: 52px;
	}
	.rightNewsList .listArr .newsDesc,
	.rightNewsList .listArr .newsDate
	{
		color: #999;
		padding-top: 10px;
	}
</style>
<style>
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #C32A1A;
	}
</style>
